import moment from 'moment'
import 'moment/locale/es-mx';
import React, {useState, useEffect, useRef} from 'react'
import firebase from '../firebase/config'
import Axios from 'axios'
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Compress from "react-image-file-resizer";
import * as XLSX from "xlsx";

function Prueba(){
        
  let variantsDefaultList = [
    "Color",
    "Tamaño",
    "Sabor"
  ]

  const [user, setUser] = useState({})
    const [listObjects, setListObjects] = useState([])
    const [listErrors, setListErrors] = useState([])
    const [listTitle, setListTitle] = useState([])
    const [variantsDefaultListNew, setVariantsDefaultListNew] = useState([])
    const [listCombinations, setListCombinations] = useState([])
    const [listMain, setListMain] = useState( [] )
    const [listOfPlaces, setListOfPlaces] = useState([])
    
    const [num, setNum] = useState(0)
    const [titleValue, setTitleValue] = useState("");
    const [name, setName] = useState("")
    const [itemTitulo, setItemTitulo] = useState("")
    const [itemPrecio, setItemPrecio] = useState(0)
    const [itemName, setItemName] = useState("")
    const [itemPrice, setItemPrice] = useState(0)
    
    let inputListTag = useRef(null)
    const hiddenFileInput = useRef(null);

    const [pruebaObjeto, setPruebaObjeto] = useState({
      nombre: "",
      desc: ""
    })

    const [productos, setProductos] = useState([])

    const [editorState, onEditorStateChange] = React.useState(
      () => EditorState.createEmpty(),
    );

    // async function showProductos(){
    //   let tipos = []
    //   try{
    //     await firebase.db.collection("Productos").where("categoria", "==", "").get().then((val)=>{
    //       val.docs.forEach((doc)=>{
    //         tipos.push(doc.data())
    //       })
    //       setProductos(tipos)
    //     })
    //   }catch(e){
    //     console.log("Error:" + e)
    //   }
    // }

    // function filterProductos(){
    //   let tipos = []
    //   for(let i = 0; i < productos.length; i++){
    //     let u = productos[i].descripcion
    //     if( u.includes("Fórmula") || u.includes("fórmula") ){
    //       tipos.push(productos[i])
    //     }
    //   }
    //   setProductos(tipos)
    // }

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');

    const handleClickImage = event => {
      hiddenFileInput.current.click();
    };

    async function handleChangeImage(e) {
      var file = e.target.files[0]
      Compress.imageFileResizer(
        file,
        600,
        300,
        "JPEG",
        10,
        0,
        (uri) => {
          setFile(uri)
          console.log(uri)
        },
        "file",
        600,
        300
      )
      setImg(URL.createObjectURL(file))
  }

    function createVariant(value){
      setName(value)
      if(value.includes(",")){
        let object = {}
        object["name"] = name.replace(",", "")
        object["items"] = []
        setListObjects([...listObjects, object])
        setName("")
      }
    }

    const handleKeyPress = (event) => {
      if(event.key === 'Enter' && name !== ""){
        let object = {}
        object["name"] = name
        object["items"] = []
        setListObjects([...listObjects, object])
        setName("")
      }
    }
    
    const handleKeyPressTag = (event, i) => event.key === 'Enter' && createListItem(i, event.target.value)
    
    function createItem(iName, iPrice, i){
      let list = listObjects[i].items
      let object = {}
      object["name"] = iName
      object["price"] = iPrice
      
      list.push(object)
      
      listObjects[i].items = list
    }
    
    function deleteItem(object, i, itemList){
      listObjects[itemList].items.filter((itemPrev) => itemPrev !== object)
    }

    const [listaPrueba, setListaPrueba] = useState([
      {
        nombre: "Prueba de nombre 1",
        activo: false
      },
      {
        nombre: "Prueba de nombre 2",
        activo: false
      },
      {
        nombre: "Prueba de nombre 3",
        activo: false
      },
    ])
    
    function createList(){
      let list = [...listMain]
      list.push([])
      setListMain(list)

      let listT = [...listTitle]
      listT.push(titleValue)
      setListTitle(listT)
      setTitleValue("")
    }

    function createListItem(i){
      let o = {
        text: itemTitulo,
        precio: itemPrecio,
        image: src !== "" ? src : ""
      }

      let list = [...listMain]
      list[i].push(o)

      setListMain(list)
      test(list)
      setImg("")
      setURL("")
      setFile(null)
    } 

    function changeStatus(i, o){
      let lista = [...listaPrueba]
      lista[i].activo = !o
      setListaPrueba(lista)
    }
    
    function changePriceCombo(i, val){
      let lista = [...listCombinations]
      lista[i].price = parseFloat(val)
      setListCombinations(lista)
    }
    
    function changeSkuCombo(i, val){
      let lista = [...listCombinations]
      lista[i].stock = parseInt(val)
      setListCombinations(lista)
    }
    
    function deleteTagFromList(tag, iMain, iSub){
      let lista = [...listMain]
      let newLista = lista[iMain].filter((prv) => prv !== tag)
      lista[iMain] = newLista
      setListMain(lista);
      test(lista)
    }
    
    function test(listMainFromOther){
      new Promise((resolve) => setTimeout(()=>{
        combinationsFunction(listMainFromOther)
      }, 1000));
    }

    function deleteVariantFromList(ele){
      if(listMain.length !== 0){
        let newLista = listMain.filter((prev) => prev !== ele)
        setListMain(newLista)
        test(newLista)
      }
    }

    function checkInputs(o){
      let val = 0
      let array = []
      Object.keys(o).forEach(function(key) {
        if (o[key] === '') {
          val++
          array.push(key)
        }
      });
      if(val > 0){
        setListErrors(array)
      }else{
        setListErrors([])
        console.log("Todo bien")
      }
    }
    
    let testMainListProducts = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "Ñ",
      "O",
      "P",
      "Q",
    ]

    const [paginationItemsList, setPaginationItemsList] = useState([])
    const [dividedList, setDividedList] = useState([])
    const [paginationList, setPaginationList] = useState([])
    const [selectedIndexPagination, setSelectedIndexPagination] = useState(0)

    function divideList(){

      let finalList = []

      let maxNumber = 7
      let cantidadItems = testMainListProducts.length

      let beginIndex = 0
      let endIndex = maxNumber

      let timesRepeated = cantidadItems / maxNumber

      for(let i = 0; i < timesRepeated; i++ ){
        let list = testMainListProducts.slice(beginIndex, endIndex)
        finalList.push(list)
        beginIndex = beginIndex + maxNumber
        endIndex = endIndex + maxNumber
      }

      console.log(finalList)
      setDividedList(finalList)
      setPaginationItemsList(finalList[0])
      setPaginationList(finalList)
    }

    function createVariantFromList(palabra){
      let tipos = []
      if(palabra !== ""){
        for(let i = 0; i < variantsDefaultList.length; i++){
          let w = variantsDefaultList[i]
          if(w.toLowerCase().includes(palabra.toLowerCase())){
            tipos.push(w)
          }else{
            setVariantsDefaultListNew([])
            setTitleValue(palabra)
          }
        }
        setVariantsDefaultListNew(tipos)
      }else{
        setTitleValue("")
        setVariantsDefaultListNew([])
      }
    }

    useEffect(() => {
      firebase.getCurrentUser().then((val)=>{
        setUser(val)
      })

      divideList()

    }, [])

    return (
      <div className="main-content-container container-fluid px-4">

        {/* Paginación */}
        {/* End Paginación */}

        <div style={{height: "50vh"}}></div>

        {/* <div onClick={()=>{ combinationsFunction() }} className="btn btn-primary mb-5">
          Generar combinaciones
        </div> */}

        {/* {listCombinations.length > 0 && <p className="mt-3 mb-4 color-primary h3">Combinaciones</p>} */}

        {/* <div style={{width: "65%"}}>

          {listCombinations.map((com, i)=>{
            return(
              <div className="fadeIn row no-gutters align-items-center justify-content-spacebetween mb-3">
                <div onClick={()=>{ setListCombinations(listCombinations.filter((comPrev) => comPrev !== com)); }} className="btn btn-danger col-lg-1">X</div>
                <p className="mb-0" key={i}>{com.combo}</p>
                
                <div className="col-lg-1">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">$</span>
                    </div>
                    <input type="number" className="form-control" defaultValue={com.price} onChange={(e)=>{ changePriceCombo(i, e.target.value) }} placeholder="0.0" />
                  </div>
                </div>
                
                <input type="number" className="form-control col-lg-2" defaultValue={com.stock} onChange={(e)=>{ changeSkuCombo(i, e.target.value) }} placeholder="Cantidad" />
              </div>
            )
          })}
        
        </div> */}

        {/* End Combinaciones */}

        {/* <div style={{height: "50vh"}}></div> */}

        {/* Editor de texto */}
        {/* <div className="col-lg-7">
        
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={onEditorStateChange}
          />
          <p>{draftToHtml(convertToRaw(editorState.getCurrentContent()))}</p>

        </div> */}
        {/* End Editor de texto */}

        {/* Prueba de campos con errores */}
        {/* <input type="text" value={pruebaObjeto.nombre} onChange={(e)=>{ setPruebaObjeto({...pruebaObjeto, nombre: e.target.value}) }} className={`${listErrors.includes("nombre") && "border-danger"} form-control col-lg-3 mb-2`} />
        {listErrors.includes("nombre") && <p>Error</p>}
        <input type="text" value={pruebaObjeto.desc} onChange={(e)=>{ setPruebaObjeto({...pruebaObjeto, desc: e.target.value}) }} className={`${listErrors.includes("desc") && "border-danger"} form-control col-lg-3 mb-2`} />
        {listErrors.includes("desc") && <p>Error</p>}
        <div className="btn btn-primary mb-3" onClick={()=>{ checkInputs(pruebaObjeto) }}>Probar</div> */}
        {/* End prueba de campos con errores */}

        {/* Cambiar estatus de algo en una lista */}
        {/* {listaPrueba.map((ob, i)=>{
          return(
            <>
              <div className="row no-gutters">
                <div className="col-lg-6">{ob.nombre}</div>
                <div className="col-lg-6">
                  <p onClick={()=>{ changeStatus(i, ob.activo) }} className={`${ ob.activo ? "color-success" : "color-danger" }`}>{ob.activo ? "Activo" : "Apagado" }</p>
                </div>
              </div>
              {ob.activo && "Prueba"}
            </>
          )
        })} */}
        {/* End cambiar estatus de algo en una lista */}

        {/* <div className="">

          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <input onKeyPress={handleKeyPress} value={name} className="col-lg-6 form-control" placeholder="Nombre" onChange={(e)=>{ createVariant(e.target.value); }}/>
              </div>
            </div>
          </div>

          {listObjects.map((o, itemList)=>{
            return(
              <div className="fadeInTop">
                <div className="row mt-3">
                  <div className="col-lg-6">
                    
                    <div className="row" key={itemList}>
                      <p className="col-lg-6 mb-0">{o.name}</p>
                    </div>

                  </div>
                  <div className="col-lg-6">
                    <div onClick={()=>{ setListObjects(listObjects.filter((p1) => p1 !== o)); }} className="material-icons color-danger cursor-pointer">delete</div>
                  </div>
                </div>
                <div className="px-5 mt-3">
          
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <input type="text" className="col-lg-6 form-control" placeholder="Nombre" onChange={(e)=>{ setItemName(e.target.value) }}/>
                        <input type="number" className="col-lg-6 form-control" placeholder="Precio" onChange={(e)=>{ setItemPrice(e.target.value) }}/>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div onClick={()=>{ createItem(itemName, itemPrice, itemList) }} className="btn btn-primary">{"+"}</div>
                    </div>
                  </div>

                  {o.items.map((item, i)=>{
                    return(
                      <div className="row mt-3">
                        <div className="col-lg-6">
                          
                          <div className="row" key={i}>
                            <p className="col-lg-6 mb-0">{item.name}</p>
                            <p className="col-lg-6 mb-0">{item.price}</p>
                          </div>

                        </div>
                        <div className="col-lg-6">
                          <div onClick={()=>{
                            deleteItem(o, i, itemList)
                          }} className="btn btn-danger"><i class="icon-reduced material-icons">delete</i></div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}

        </div> */}

        <div className="container">
          <input type="file" onChange={handleUploadExcel} />
          <div onClick={()=>{ uploadIntoDB() }} className="btn btn-primary">Console log</div>
        </div>
        <div className="container my-5">
          {listOfPlaces.map((p, i)=>{
            return(
              <div className="row">
                <div className="col-lg-4">{i + " - " + p["nombreComercial"]}</div>
                <div className="col-lg-4">
                  <img src={p["urlImagen"]} />
                </div>
              </div>
            )
          })}
        </div>

      </div>
    )

    function handleUploadExcel(e) {
      var selectedFile = e.target.files[0]
      let list = []
      if(selectedFile){
        var fileReader = new FileReader()
        
        fileReader.onload = function(e){
          console.log("FileReader listo")
          var data = e.target.result
          var workhook = XLSX.read(data, {
            type: "binary"
          })
  
          workhook.SheetNames.forEach((sheet)=>{
            let rowObject = XLSX.utils.sheet_to_json( workhook.Sheets[sheet], {
              defval: undefined
            } )
            // let jsonObject = JSON.stringify(rowObject)
            // console.log(jsonObject)
            // setObjects(rowObject)
            console.log(rowObject)
            setListOfPlaces(rowObject.filter((rv, i) => rv["urlImagen"] !== undefined))
            
          })
        }
        fileReader.readAsBinaryString(selectedFile)
      }

    }

    function getGeoPoint(prop){
      let removedP = prop.replace("(", "").replace(")", "")
      let removedS = removedP.replace(" ", "")
      let list = removedS.split(",")
      return list
    }

    function uploadIntoDB(){
      listOfPlaces.forEach( async (p, i)=>{
        let placeId = firebase.db.collection("Places").doc().id
        let list = getGeoPoint(p["geolocalizacion"])
        
        if(p["urlImagen"].includes("data:image/")){
          
          let o = {
              createdOn: moment().toDate(),
              description: p["direccion"],
              geolocationList: [list[0], list[1]],
              geolocation: "",
              media: [{
                index: 1,
                link: "",
                type: "photo"
              }],
              name: p["nombreComercial"],
              hasPhoto: false,
              placeId: placeId,
              subjectId: "",
              subjectType: "aliado",
              type: "Park"
          }
          
          await firebase.db.collection("Places").doc(placeId).set(o)
        }else{
          let o = {
              createdOn: moment().toDate(),
              description: p["direccion"],
              geolocationList: [list[0], list[1]],
              geolocation: "",
              media: [{
                index: 1,
                link: p["urlImagen"],
                type: "photo"
              }],
              name: p["nombreComercial"],
              placeId: placeId,
              subjectId: "",
              subjectType: "aliado",
              type: "Park"
          }
          await firebase.db.collection("Places").doc(placeId).set(o)
        }

      })
    }

    function concatObjects(obj){
      let l = []
      obj.forEach(element => {
        l.push(element.text)
      });
      return l
    }
    
    function sumObjects(obj){
      let l = 0
      obj.forEach(element => {
        l = l + parseFloat(element.precio)
      });
      return l
    }

    function combinationsFunction(lista){
      let l = lista !== undefined ? lista : listMain
      let combos = cartesian(...l)
      let list = []
      for(let i = 0; i < combos.length; i++){
        let obj = {
          combo: concatObjects(combos[i]).join(' - '),
          // price: sumObjects(combos[i]),
          price: 0,
          stock: 0
        }
        console.log(combos[i])
        list.push(obj)
      }
      setListCombinations(list)
    }

    function cartesian(...args) {
      var r = []
      var max = args.length - 1;
      function helper(arr, i) {
        for (var j = 0, l = args[i].length; j < l; j++) {
          var a = arr.slice(0);
          a.push(args[i][j]);
          if (i == max)
            r.push(a);
          else
            helper(a, i + 1);
        }
      }
      helper([], 0);
      return r;
    }

    async function approveUser(){

      const config = {
        headers: {
          'Content-type': 'application/json; charset=utf-8',
          'Access-Control-Allow-Origin':'*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers':'Content-Type',
          // 'Access-Control-Allow-Credentials': true,
          'cache-control': 'no-cache'
        }
      };
      let postData = { id: user.aliadoId }
      let res = await Axios.post('https://us-central1-priority-pet.cloudfunctions.net/aikonsPayCreateSeller', postData, config)
      console.log(res.status)

    }

}

export default Prueba
